export default defineAppConfig({
  hiyieldNuxtLayerFirebaseAuth: {
    /**
     * The amount of retries to pass to $fetch when using the $authedFetch composable.
     * @see https://github.com/unjs/ofetch#%EF%B8%8F-auto-retry
     */
    authedFetchRetryAmount: 0,
    /**
     * The type of the user object to use to type the store.
     * Use type casting here as below. The only thing this is used for is the type.
     * The type cast here will be used to type the `userDoc` ref in the auth store.
     */
    userDocType: {} as unknown,
    /**
     * The firestore collection in which to store user data.
     */
    userCollection: 'users',
    /**
     * The user defaults to use when creating a new user after signup.
     * Use the special keys `_now_` which will be replaced with the current timestamp in ISO format
     * and `_uid_` which will be replaced with the user's uid.
     */
    userDefaults: {
      created: '_now_',
      uid: '_uid_'
    }
  }
})
